import { render, staticRenderFns } from "./block-pagination.vue?vue&type=template&id=efd67de8&scoped=true"
import script from "./block-pagination.vue?vue&type=script&lang=js"
export * from "./block-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd67de8",
  null
  
)

export default component.exports